import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'likelihoodSelect',
    'likelihoodSelectAdditional',
    'irremediabilitySelect',
    'irremediabilitySelectAdditional',
    'positiveOrNegativeAdditional',
    'positiveOrNegative',
    'actualOrPotential',
    'actualOrPotentialAdditional',
  ];

  connect() {
    // Set the default state of the likelihood select elements
    if (this.hasActualOrPotentialTarget) {
      this.toggleLikelihood(this.actualOrPotentialTarget.value, 'matter_evaluation');
    }
    if (this.hasActualOrPotentialAdditionalTarget) {
      this.toggleLikelihood(
        this.actualOrPotentialAdditionalTarget.value,
        'additional_matter_evaluation'
      );
    }

    // Set the default state of the irremediability select elements
    if (this.hasPositiveOrNegativeTarget) {
      this.toggleIrremediability(this.positiveOrNegativeTarget.value, 'matter_evaluation');
    }
    if (this.hasPositiveOrNegativeAdditionalTarget) {
      this.toggleIrremediability(
        this.positiveOrNegativeAdditionalTarget.value,
        'additional_matter_evaluation'
      );
    }
  }

  likelihoodOnChange(event) {
    const value = event.target.value;
    const objectType = event.target.dataset.objectType;
    this.toggleLikelihood(value, objectType);
  }

  toggleLikelihood(value, objectType) {
    const likelihoodTarget =
      objectType === 'matter_evaluation'
        ? this.likelihoodSelectTarget
        : this.likelihoodSelectAdditionalTarget;
    const select = likelihoodTarget.querySelector('select');

    if (value === 'potential') {
      likelihoodTarget.classList.remove('hidden');
      select.required = true;
    } else {
      likelihoodTarget.classList.add('hidden');
      select.required = false;
    }
  }

  syncIrremediability(event) {
    const value = event.target.value;
    const objectType = event.target.dataset.objectType;
    this.toggleIrremediability(value, objectType);
  }

  toggleIrremediability(value, objectType) {
    const irremediabilityTarget =
      objectType === 'matter_evaluation'
        ? this.irremediabilitySelectTarget
        : this.irremediabilitySelectAdditionalTarget;
    const select = irremediabilityTarget.querySelector('select');

    // This is only triggered by the matter_evaluation form and not the additional form
    if (value === 'positive' || value === '') {
      const select = irremediabilityTarget.querySelector('select');
      irremediabilityTarget.classList.add('hidden');
      select.required = false;
    } else if (value === 'negative') {
      const select = irremediabilityTarget.querySelector('select');
      irremediabilityTarget.classList.remove('hidden');
      select.required = true;
    }
  }
}
